<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Отчеты</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Создание отчета</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4" v-if="client_id === 0 && clients.length > 0">
            <div class="form-label">Клиент <span class="color-red">*</span></div>
            <v-select
                v-model="picked_client"
                :items="clients"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Бренд <span class="color-red">*</span></div>
            <v-select
                :disabled="picked_client ? false : true"
                v-model="picked_brand"
                :items="brands"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <label for="playlist-name" class="form-label">
                Название <span class="color-red">*</span>
            </label>
            <input type="text" class="form-control" id="playlist-name" v-model="formData.name" placeholder="Название">
        </div>

        <div class="mb-4">
            <div class="w-100 me-3 mb-4">
                <label for="playlist-date-start" class="form-label">
                    Время начала <span class="color-red">*</span>
                </label>
                <input v-model="formData.time_from" type="datetime-local" class="form-control" id="exampleFormControlInput3" placeholder="Placeholder">
            </div>
            <div class="w-100">
                <label for="playlist-date-end" class="form-label">
                    Время окончания <span class="color-red">*</span>
                </label>
                <input v-model="formData.time_to" type="datetime-local" class="form-control" id="exampleFormControlInput3" placeholder="Placeholder">
            </div>
        </div>

        <div class="mb-4">
            <div class="tabs mb-2">
                <div class="tabs__ctrls">
                    <button v-on:click="clickDevices" :class="{ 'is-selected': devices }" class="reset-btn tabs__ctrl local" type="button">
                        Устройство
                    </button>
                    <button v-on:click="clickContents" :class="{ 'is-selected': contents }" class="reset-btn tabs__ctrl cloud" type="button">
                        Контент
                    </button>
                    <span class="color-red">*</span>
                </div>
            </div>
        </div>

        <div class="mb-3" v-if="devices">
            <v-select
                v-model="selectedDevice"
                :items="list_devices"
                item-title="item"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>
    </div>

    <report-create-content-element v-if="contents" :contents="contents_data" @contentDir="loadDir" @pickItem="pickItem"></report-create-content-element>

    <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createReport"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ReportCreateContentElement from "./ReportCreateContentElement.vue";
import ReportCreateGroupElement from "./ReportCreateGroupElement.vue";
import ReportCreateDeviceElement from "./ReportCreateDeviceElement.vue";
import Report from "../../../../models/Report";
import Content from "../../../../models/Content";
import SelectBackSearchableElement from "../../../../elements/SelectBackSearchableElement.vue";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations, mapState } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";

export default {
    name: 'ReportCreateComponent',
    components: {
        Alert,
        SelectBackSearchableElement,
        ReportCreateDeviceElement,
        ReportCreateGroupElement,
        ReportCreateContentElement,
        ConfirmBtn
    },
    props: {
        route_back: String,
        route_create: String,
        route_client_search: String,
        route_brand_search: String,
        route_content_list: String,
        route_dir_content: String,
        route_devices: String,
        route_devices_search: String,
        route_device_groups_search: String,
        route_content_list_commercial: String,
        client_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            report: new Report({
                route_create: this.route_create,
                route_client_search: this.route_client_search,
                route_brand_search: this.route_brand_search,
                route_devices_search: this.route_devices_search,
                route_device_groups_search: this.route_device_groups_search
            }),
            content: new Content({
                route_list: this.route_content_list_commercial,
                route_dir_content: this.route_dir_content,
            }),
            devices: false,
            groups: false,
            contents: true,
            formData: {
                name: '',
                time_from: '',
                time_to: '',
                client_id: 0,
                brand_id: 0,
                items: []
            },
            picked_client: null,
            picked_brand: null,
            contentWasPicked: false,
            brands: [],
            clients: [],
            contents_data: [],
            devices_founded: [],
            devices_pages: 1,
            groups_founded: [],
            numberPharmacy: '',
            city: '',
            address: '',
            isOpenDropDown: false,
            selectedDevices: [],
            selectedDevice: '',
            list_devices: [],
        }
    },
    watch: {
        picked_client: function () {
            this.formData.client_id = this.picked_client;
            this.searchBrands();
        },
        picked_brand: function () {
            this.formData.brand_id = this.picked_brand;
            this.getContent();
            this.loadDevices('', 99999, 1);
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createReport: async function () {
            if (!await this.validateForm()) return false;
            if (this.devices) {
                this.formData.items = {
                    id: this.selectedDevice
                }
            }

            if (this.devices) {
                this.formData.type_id = 1;
            } else if (this.groups) {
                this.formData.type_id = 2;
            } else if (this.contents) {
                this.formData.type_id = 3;
            }
            let result = await this.report.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_report');
            }
        },
        validateForm: async function() {
            if (!this.formData.client_id) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите клиента' });
                this.toggleLoading();
                return false;
            }
            if (!this.formData.brand_id) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите бренд' });
                this.toggleLoading();
                return false;
            }
            if (this.formData.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, укажите название' });
                this.toggleLoading();
                return false;
            }
            if (this.formData.time_from === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите время начала' });
                this.toggleLoading();
                return false;
            }
            if (this.formData.time_to === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите время окончания' });
                this.toggleLoading();
                return false;
            }
            const timeFrom = new Date(this.formData.time_from);
            const timeTo = new Date(this.formData.time_to);
            if (timeFrom >= timeTo) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Время начала не может быть позже времени окончания!' });
                this.toggleLoading();
                return false;
            }
            if (this.devices && !this.selectedDevice) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите устройство' });
                this.toggleLoading();
                return false;
            }
            if (this.contents && this.contentWasPicked === false) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Пожалуйста, выберите контент' });
                this.toggleLoading();
                return false;
            }
            return true;
        },
        syncContent: function (content) {
            this.formData.items = content;
        },
        syncDevices: function (devices) {
            this.formData.items = devices;
        },
        loadDevices: async function (search, limit, page) {
            let data = await this.report.devices({
                search: search,
                limit: limit,
                page: page,
                client_id: this.picked_client,
                brand_id: this.picked_brand
            });
            this.devices_founded = data.items;
            this.devices_pages = data.pages;
            await this.getDevices(this.devices_founded);
        },
        pickItem: function (item) {
            if(item.type == 1) {
                this.formData.items = [item];
                this.contentWasPicked = true;
                this.selectedDevice = null;
            }
        },
        loadDir: async function (item) {
            if (item.type == 2) {
                let result = await this.content.loadDir(item.id);
                item.content = result.items;
                return result;
            }
        },
        getContent: async function () {
            let response = await this.content.loadTable(
                1,
                1000,
                '',
                {
                    client_id: this.formData.client_id,
                    brand_id: this.formData.brand_id,
                    is_statistics_enabled: true
                }
            );
            this.contents_data = response.items;
        },
        searchBrands: async function () {
            let brands = await this.report.brands({
                client_id: this.picked_client
            });
            this.brands = brands.items;
        },
        searchClients: async function () {
            let clients = await this.report.clients();
            this.clients = clients.items;
        },
        clickDevices: function () {
            this.devices = true;
            this.groups = false;
            this.contents = false;
            this.contentWasPicked = false;
        },
        clickGroups: function () {
            this.devices = false;
            this.groups = true;
            this.contents = false
        },
        clickContents: function () {
            this.devices = false;
            this.groups = false;
            this.contents = true;
            this.contentWasPicked = false;
        },
        searchDevices: async function () {
            let devices = await this.license.devices();
            this.devices = devices.items;
        },
        getDevices: async function (devices) {
            if (devices) {
                for (let i = 0; i < devices.length; i++) {
                    this.list_devices[i] = {
                        id: devices[i].id,
                        item: devices[i].location.number + ', ' + devices[i].location.street + ', ' + devices[i].type.name + ' ' + devices[i].item
                    }
                }
            }

            if (!devices) {
                this.list_devices = []
            }
        },
        openDropDown: async function () {
            await this.getDevices();
            this.isOpenDropDown = true;
        },
        closeDropDown: function() {
            this.isOpenDropDown = false;
        },
        onGetDevices: async function () {
            await this.getDevices();
        },
        onCancelGetDevicesByNumberPharmacy: async function () {
            if (this.numberPharmacy.trim() == '') {
                await this.getDevices();
            }
        },
        selectDevice: function (device) {
            const found = this.selectedDevices.find((el) => device.id == el.id)
            if (!found) {
                this.selectedDevices = [...this.selectedDevices, device];
            }
        },
        onDelDevice: function (device) {
            this.selectedDevices = this.selectedDevices.filter(el => el.id != device.id)
        },
    },
    mounted() {
        this.searchClients();
    }
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
    top:-500%;
}

.app-dropdown .disable{
    background-color: #ddd;
    cursor: initial;
}
</style>

